<template>
    <div id="vy_main" style="overflow-x:hidden">
      <main>
        <!--ヘッダー-->
        <HeaderArea />

        <div id="main_area">
          <h2>社協一覧</h2>

          <select style="
            margin: 20px 0 0 0;
            font-size: 20px;" v-model="shakyo">
            <option value="kawagoe">川越</option>
            <option value="tsurugashima">鶴ヶ島</option>
            
            
          </select>

          <div id="link_area">

            <div style="
              width: 100%;
              display: flex;
              justify-content: space-evenly;">
              <span v-on:click="Volunter">
                ボランティア一覧
              </span>
              <span v-on:click="Taiken">
                体験プログラム一覧
              </span>
            </div>
            <span v-on:click="ShakyoPolicy">
              川越社協プライバシーポリシー
            </span>
          </div>
        </div>
        <!--フッター-->
        <FooterArea />
      </main>
    </div>
</template>
  
    
<script setup>
  /* eslint-disable */
  import HeaderArea from './HomeHeader.vue'
  import FooterArea from './HomeFooter.vue'

  import { useStore } from 'vuex'
  const store = useStore()
    
import { useRouter,useRoute } from 'vue-router'

/* 変数の記述 */
let router = useRouter()
  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント
  import { shallowRef, watch, ref } from 'vue'
  const content = shallowRef('')


  // 選択中の社協
  let shakyo = ref("kawagoe")
  
  let Taiken = function(){
    let set_path = "/"+shakyo.value+"/Taiken"
    store.state.access_shakyo = shakyo.value
    
    router.push(set_path)
//    window.open(set_path,"_blank")
  }

  let Volunter = function(){
    alert("準備中です。")
  }

  let ShakyoPolicy = function(){
    let set_path = "/"+shakyo.value+"/Taiken/Policy"
    store.state.access_shakyo = shakyo.value
    router.push(set_path)
  }
</script>
  
<style scoped>

  #main_area{
    margin-top:30px;
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #link_area{
    font-size: 17px;
    display: flex;
    justify-content: space-evenly;
    width: 50%;
    height: 200px;
    align-items: center;
    flex-direction: column;
  }
  #link_area span{
    color:black;
    cursor: pointer;
    text-decoration-line:underline
  }

</style>
  